import React, { useCallback, useState } from 'react';
import classnames from 'classnames';

import { Item } from 'src/assets/data/our-way-of-working';
import ChevronDownIcon from 'src/assets/images/chevron-down-white.svg';

interface ExpandableCardsProps {
  data: Item[];
}

const ExpandableCards = ({ data }: ExpandableCardsProps) => {
  const [expandedIndex, setExpandedIndex] = useState<number | undefined>(undefined);

  const expandCard = useCallback(
    (index: number) => {
      if (expandedIndex === index) {
        setExpandedIndex(undefined);
      } else {
        setExpandedIndex(index);
      }
    },
    [expandedIndex]
  );

  return (
    <div className="our-way-cards expandable-cards-mobile">
      {data.map((item, index) => (
        <div key={index} className="card-item">
          <div className="card-item-content">
            <div className="paragraph-3" dangerouslySetInnerHTML={{ __html: item.title }} />

            <img
              className={classnames('chevron-icon', {
                expanded: expandedIndex === index,
              })}
              src={ChevronDownIcon}
              alt="chevron"
              onClick={() => {
                expandCard(index);
              }}
            />
          </div>

          <div
            className={classnames('card-item-content-expanded', {
              show: expandedIndex === index,
            })}
          >
            <div className="paragraph-4" dangerouslySetInnerHTML={{ __html: item.text }} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ExpandableCards;
